import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentTrackingTable = ({ invoices }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    const statusColors = {
      'paid': 'text-success bg-success/10',
      'open': 'text-warning bg-warning/10',
      'draft': 'text-muted-foreground bg-muted',
      'void': 'text-error bg-error/10',
      'uncollectible': 'text-error bg-error/10'
    };
    return statusColors?.[status] || 'text-muted-foreground bg-muted';
  };

  const getPaymentMethod = (invoice) => {
    // Determine payment method based on invoice data
    return invoice?.status === 'paid' ? 'Stripe Card' : 'Pending';
  };

  if (!invoices || invoices?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="CreditCard" size={48} className="mx-auto text-muted-foreground mb-4" />
        <p className="text-muted-foreground">No payment records available</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Client Name</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Invoice Amount</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Payment Method</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Processing Status</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Transaction Date</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices?.map((invoice) => (
            <tr key={invoice?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-3 px-4 text-sm font-medium text-foreground">
                Client #{invoice?.id?.slice(0, 8)?.toUpperCase()}
              </td>
              <td className="py-3 px-4 text-sm font-semibold text-foreground">
                K{parseFloat(invoice?.amountDue || 0)?.toFixed(2)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {getPaymentMethod(invoice)}
              </td>
              <td className="py-3 px-4">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  getStatusColor(invoice?.status)
                }`}>
                  {invoice?.status?.toUpperCase()}
                </span>
              </td>
              <td className="py-3 px-4 text-sm text-muted-foreground">
                {formatDate(invoice?.createdAt)}
              </td>
              <td className="py-3 px-4 text-right">
                <div className="flex items-center justify-end gap-2">
                  {invoice?.invoicePdfUrl && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => window.open(invoice?.invoicePdfUrl, '_blank')}
                    >
                      <Icon name="Download" size={14} />
                    </Button>
                  )}
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => console.log('View details:', invoice?.id)}
                  >
                    <Icon name="Eye" size={14} />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentTrackingTable;